/**
 * Shared cap for the site/workspace selectors and the permissions list, so they
 * share a right edge as the right panel grows and shrinks.
 */
export const FIELD_MAX_WIDTH = '550px';
